// component variants
export const THEME_VARIANTS = [
  'primary',
  'secondary',
  'accent',
  'success',
  'danger',
  'warning',
  'info',
  'light',
  'dark',
]
export const BUTTON_VARIANTS = [
  ...THEME_VARIANTS,
  'link',
]

// status variants
export const STATUS_VARIANTS = [
  'success',
  'warning',
  'danger',
  'info',
]

// toggle group shapes
export const TOGGLE_GROUP_SHAPES = {
  grouped: 'btn-group',
  pills: 'toggle-pills',
}

// component sizes
export const SIZES = ['sm', 'lg']
export const DIALOG_SIZES = ['sm', 'md', 'lg', 'xl']

// converters from Radix values to Bootstrap
export const RADIX_TO_BOOTSTRAP_PLACEMENT = {
  top: 'top',
  bottom: 'bottom',
  center: 'center',
  left: 'start',
  right: 'end',
}

export const BOOTSTRAP_SIZES = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
  extraLarge: 'xl',
}

export const DROPDOWN_DIRECTION = {
  left: 'dropstart',
  right: 'dropend',
  top: 'dropup',
  bottom: 'dropdown',
}
